type Props = {
  eyebrow?: string;
  headline: string;
  sub?: string;
  ctaLabel?: string;
  variant?: "default" | "alt";
};

export default function ArqInlineCTA({
  eyebrow,
  headline,
  sub,
  ctaLabel = "Book a Readiness Review",
  variant = "default",
}: Props) {
  const bg = variant === "alt" ? "bg-arq-bg" : "bg-arq-surface1";
  return (
    <section className={`${bg} py-16 md:py-20 px-6`}>
      <div className="max-w-[1100px] mx-auto">
        <div className="arq-card p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 border-arq-blue/30 ring-1 ring-arq-blue/20">
          <div className="max-w-[680px]">
            {eyebrow && (
              <div className="font-mono-tech text-[11px] tracking-[0.14em] uppercase text-arq-blue mb-2">
                {eyebrow}
              </div>
            )}
            <h3
              className="font-display font-semibold text-arq-text mb-2 leading-tight"
              style={{ fontSize: "clamp(22px, 2.4vw, 28px)" }}
            >
              {headline}
            </h3>
            {sub && (
              <p className="text-arq-muted text-[15px] leading-[1.65]">{sub}</p>
            )}
          </div>
          <button
            onClick={() =>
              document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })
            }
            className="shrink-0 bg-arq-blue text-white font-semibold text-[15px] px-7 py-4 rounded-md hover:bg-arq-blue-bright hover:shadow-[0_0_24px_rgba(26,111,212,0.35)] transition-all duration-150 whitespace-nowrap"
          >
            {ctaLabel}
          </button>
        </div>
      </div>
    </section>
  );
}
